/**
 * The initials shown for a person when there is no photo. One rule for the whole app.
 *
 * The name they go by (preferred name, else first name) plus their last name's
 * initial. Accepts the shapes people arrive in around the app: users rows
 * (first_name, last_name, preferred_name), camelCase objects from the merge
 * preview, and objects that only carry a display `name`. Falls back to the first
 * letter of an email or username, and to "?" when there is nothing at all.
 */
export function personInitials(person) {
  if (!person) return '?';
  if (typeof person === 'string') return initialsFromName(person);

  const first = (person.preferred_name || person.preferredName || person.first_name || person.firstName || '').trim();
  const last = (person.last_name || person.lastName || '').trim();
  if (first || last) return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase() || '?';

  if (person.name) return initialsFromName(person.name);

  const handle = (person.email || person.username || person.stern_username || '').trim();
  return handle ? handle.charAt(0).toUpperCase() : '?';
}

/** "Mary Ann Smith" gives "MS": the first word and the last. */
function initialsFromName(name) {
  const words = String(name).trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  const first = words[0].charAt(0);
  const last = words.length > 1 ? words[words.length - 1].charAt(0) : '';
  return `${first}${last}`.toUpperCase();
}
